import React from 'react';
import { mediaUrl } from '../utils/media';
import { DONATE_URL } from '../utils/donate';

interface Service {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const YogaIcon: React.FC = () => (
  <svg className="service-icon" viewBox="0 0 90 90" aria-hidden="true">
    <circle cx="45" cy="18" r="8" fill="#F6C28B" />
    <path fill="#FF6F0F" d="M45 28c-7 0-12 4-12 9v8h24v-8c0-5-5-9-12-9z" />
    <path fill="#E85D04" d="M16 58c8-12 16-14 24-6 3 10-6 18-16 20-8 2-14-4-8-14z" />
    <path fill="#E85D04" d="M74 58c-8-12-16-14-24-6-3 10 6 18 16 20 8 2 14-4 8-14z" />
    <path fill="#FF6F0F" d="M22 42c-6 3-8 8-5 11 6-2 11-6 13-11h-8zm46 0c6 3 8 8 5 11-6-2-11-6-13-11h8z" />
  </svg>
);

const ServicesSection: React.FC = () => {
  const services: Service[] = [
    {
      icon: <img className="service-icon" src={mediaUrl('icon-1.png')} alt="" />,
      title: 'Child Education',
      description: 'Providing quality education and learning opportunities to children in underserved communities.',
    },
    {
      icon: <img className="service-icon" src={mediaUrl('icon-3.png')} alt="" />,
      title: 'Tree Plantation',
      description: 'Planting trees to restore forests, improve air quality, and build sustainable green communities.',
    },
    {
      icon: <YogaIcon />,
      title: 'Yoga Awareness',
      description: 'Sharing yoga with communities to support healthier habits, focus, and everyday wellbeing.',
    },
  ];

  return (
    <div className="container-xxl py-5">
      <div className="container">
        <div className="text-center mx-auto mb-5" data-aos="fade-up" data-aos-delay="100" style={{ maxWidth: '500px' }}>
          <div className="d-inline-block rounded-pill bg-secondary text-primary py-1 px-3 mb-3">
            What We Do
          </div>
          <h1 className="display-6 mb-5">Learn More What We Do And Get Involved</h1>
        </div>
        <div className="row g-4 justify-content-center">
          {services.map((service, index) => (
            <div key={index} className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay={`${100 + index * 200}`}>
              <div className="service-item bg-white text-center h-100 p-4 p-xl-5">
                <div className="mb-4">{service.icon}</div>
                <h4 className="mb-3">{service.title}</h4>
                <p className="mb-4">{service.description}</p>
                <a
                  className="btn btn-outline-primary px-3"
                  href={DONATE_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Donate Now
                  <div className="d-inline-flex btn-sm-square bg-primary text-white rounded-circle ms-2">
                    <i className="fa fa-arrow-right"></i>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ServicesSection;

